import React from 'react';
import { Link } from 'react-router-dom';
import './TeamHeader.scss';
import { useTranslation } from 'react-i18next';
import { FiClock, FiPhone, FiMapPin, FiArrowRight, FiZap, FiShield } from 'react-icons/fi';
import { MdOutlineCalendarToday } from 'react-icons/md';
import teamPhoto from '../../assets/home/team-photo.jpg';

const TeamHeader = () => {
    const { t } = useTranslation();

    return (
        <section className='hero-section' data-aos="fade-up">
            <div className="hero-decoration" aria-hidden="true"></div>
            <div className="container">
                <div className="hero-visual" data-aos="fade-up">
                    <div className="hero-team-photo">
                        <img src={teamPhoto} alt={t('hero.teamPhotoAlt')} loading="eager" width="1915" height="821" />

                        <div className="hero-team-photo__content">
                            <h1 className="hero-headline" data-aos="fade-up" data-aos-delay="150">
                                {t('hero.headlinePrefix')} <span className="highlight">{t('hero.headlineHighlight')}</span> {t('hero.headlineSuffix')}
                            </h1>
                            <h2 className="hero-welcome" data-aos="fade-up" data-aos-delay="300">
                                {t('hero.welcomeTitle')}
                            </h2>
                        </div>
                    </div>

                    <div className="hero-info-bar">
                        <div className="info-item" data-aos="fade-up" data-aos-delay="100">
                            <div className="info-icon"><FiClock /></div>
                            <div className="info-content">
                                <span className="info-label">{t('hero.hoursLabel')}</span>
                                <span className="info-value">{t('hero.hoursValue')}</span>
                            </div>
                        </div>
                        <div className="info-item" data-aos="fade-up" data-aos-delay="150">
                            <div className="info-icon"><FiPhone /></div>
                            <div className="info-content">
                                <span className="info-label">{t('hero.phoneLabel')}</span>
                                <a className="info-value" href={`tel:${t('footer.phone')}`}>{t('hero.phoneDisplay')}</a>
                            </div>
                        </div>
                        <div className="info-item" data-aos="fade-up" data-aos-delay="200">
                            <div className="info-icon"><FiMapPin /></div>
                            <div className="info-content">
                                <span className="info-label">{t('hero.addressLabel')}</span>
                                <span className="info-value">{t('footer.address')}</span>
                            </div>
                        </div>
                        <div className="info-item info-item--cta" data-aos="fade-up" data-aos-delay="250">
                            <div className="info-icon"><MdOutlineCalendarToday /></div>
                            <div className="info-content">
                                <span className="info-label">{t('hero.appointmentLabel')}</span>
                                <Link className="info-value info-link" to="/kontakt">
                                    {t('hero.appointmentCta')} <FiArrowRight />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row hero-description">
                    <div className="col-lg-6">
                        <p className="hero-text">{t('hero.description1')}</p>
                    </div>
                    <div className="col-lg-6">
                        <p className="hero-text">{t('hero.description2')}</p>
                    </div>
                </div>

                <div className="row hero-features">
                    <div className="col-md-4">
                        <div className="hero-feature" data-aos="fade-up" data-aos-delay="0">
                            <div className="hero-feature__icon"><FiClock /></div>
                            <h4>{t('hero.feature1Title')}</h4>
                            <p>{t('hero.feature1Desc')}</p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="hero-feature" data-aos="fade-up" data-aos-delay="100">
                            <div className="hero-feature__icon"><FiZap /></div>
                            <h4>{t('hero.feature2Title')}</h4>
                            <p>{t('hero.feature2Desc')}</p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="hero-feature" data-aos="fade-up" data-aos-delay="200">
                            <div className="hero-feature__icon"><FiShield /></div>
                            <h4>{t('hero.feature3Title')}</h4>
                            <p>{t('hero.feature3Desc')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TeamHeader;
